// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2QWZR","title":"FrontImage_title__2RwfS"};